import { logger } from './logger'

/**
 * Runs a promise-returning function from a caller that cannot await it — a timer, a lifecycle
 * hook, a third-party listener — and logs a rejection rather than leaving it unhandled.
 *
 * Use this where the promise can reject. Where the callback already handles every failure
 * itself, a plain `void` at the call site says so more directly.
 */
export const fireAndForget = (label: string, run: () => Promise<unknown>): void => {
  run().catch(error => logger.error(label, error))
}
